import axios from 'axios'
import config from '../utils/config'

const LEAVE_REQUEST_ENDPOINT = config.api[process.env.NODE_ENV].pre
const HC_360_ENDPOINT = config.api[process.env.NODE_ENV].hc360

/**
|--------------------------------------------------
| [GET] List Leave Request Type
| @param {string} employeeId
|--------------------------------------------------
*/
export const leaveRequestTypes = ({ employeeId }) =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequestType`, {
      headers: {
        EmployeeId: employeeId
      }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Leave Request
| @param {string} employeeId
| @param {number} page
| @param {number} pageSize
|--------------------------------------------------
*/
const defaultListLeaveRequestParams = {
  employeeId: ''
}
export const listLeaveRequest = (params = defaultListLeaveRequestParams) =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequest`, {
      headers: {
        ...params
      }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Leave Request Manager
| @param {string} employeeId
|--------------------------------------------------
*/
const defaultListLeaveRequestManagerParams = {
  page: 1,
  pageSize: 100,
  approvalEmployeeId: ''
}
export const listLeaveRequestManager = (
  params = defaultListLeaveRequestManagerParams
) =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequest/Approval`, { headers: { ...params } })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Detail Leave Request
| @param {string} requestId
|--------------------------------------------------
*/
const defaultDetailLeaveRequestParams = ''
export const detailLeaveRequest = (
  requestId = defaultDetailLeaveRequestParams
) =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequest/${requestId}`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Leave Request Static
| @param {string} employeeId
| @param {number} year
|--------------------------------------------------
*/
const defaultLeaveRequestStaticParams = {
  employeeId: '',
  year: new Date().getFullYear()
}
export const leaveRequestStaticSummary = (
  params = defaultLeaveRequestStaticParams
) =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequest/Static`, {
      headers: { ...params }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Leave Request Static
| @param {string} employeeId
| @param {number} year
|--------------------------------------------------
*/
const annualLeaveSummaryParams = {
  employeeId: '',
  year: new Date().getFullYear()
}
export const annualLeaveSummary = (params = annualLeaveSummaryParams) =>
  axios
    .get(`${HC_360_ENDPOINT}/AnnualLeaveSummary`, {
      headers: { ...params }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [POST] Create Leave Request
| @param {string} LeaveTypeId - DaysOff's Type
| @param {string} EmployeeId
| @param {string} Note - Reason to leave
| @param {number} DaysOff
| @param {string} StartDate - DD/MM/YYYY
| @param {string} EndDate - DD/MM/YYYY
| @param {string} Time - AM/PM
|--------------------------------------------------
*/
const defaultCreateLeaveRequestParams = {
  LeaveTypeId: '',
  EmployeeId: '',
  Note: '',
  DaysOff: 0,
  StartDate: '',
  Time: '',
  EndDate: '',
  ReliefEmployeeId: ''
}
export const createLeaveRequest = (params = defaultCreateLeaveRequestParams) =>
  axios
    .post(`${HC_360_ENDPOINT}/LeaveRequest`, { ...params })
    .then(response => response.data)

/**
|--------------------------------------------------
| [PUT] Edit Leave Request
| @param {string} LeaveTypeId - DaysOff's Type
| @param {string} EmployeeId
| @param {string} Note - Reason to leave
| @param {number} DaysOff
| @param {string} StartDate - DD/MM/YYYY
| @param {string} EndDate - DD/MM/YYYY
| @param {string} Time - AM/PM
|--------------------------------------------------
*/
const defaultEditLeaveRequestParams = {
  LeaveTypeId: '',
  EmployeeId: '',
  Note: '',
  DaysOff: 0,
  StartDate: '',
  Time: '',
  EndDate: '',
  ReliefEmployeeId: ''
}
export const editLeaveRequest = (
  leaveRequestID,
  params = defaultEditLeaveRequestParams
) =>
  axios
    .put(`${LEAVE_REQUEST_ENDPOINT}/LeaveRequest/${leaveRequestID}`, {
      ...params
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [PATCH] Approve Leave Request
|--------------------------------------------------
*/
export const approveLeaveRequest = leaveRequestId =>
  axios
    .post(
      `${HC_360_ENDPOINT}/LeaveRequest/Approve`,
      {},
      { headers: { leaveRequestId } }
    )
    .then(response => response.data)

/**
|--------------------------------------------------
| [PATCH] Reject Leave Request
|--------------------------------------------------
*/
export const rejectLeaveRequesst = leaveRequestId =>
  axios
    .post(
      `${HC_360_ENDPOINT}/LeaveRequest/Reject`,
      {},
      { headers: { leaveRequestId } }
    )
    .then(response => response.data)

/**
|--------------------------------------------------
| [DELETE] Delete Leave Request
|--------------------------------------------------
*/
export const deleteLeaveRequest = leaveRequestID =>
  axios
    .delete(`${HC_360_ENDPOINT}/LeaveRequest`, {
      headers: { leaveRequestId: leaveRequestID }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Holidays
|--------------------------------------------------
*/
const defaulGetHolidaysParams = {
  fromYear: 2017,
  toYear: 2018
}
export const getHolidays = (params = defaulGetHolidaysParams) =>
  axios
    .get(`${LEAVE_REQUEST_ENDPOINT}/Holiday`, {
      params: { ...params }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Config
|--------------------------------------------------
*/
export const getConfig = ({ employeeId }) =>
  axios
    .get(
      `${LEAVE_REQUEST_ENDPOINT}/LeaveRequest/Config?employeeId=${employeeId}`
    )
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Leave Request
|--------------------------------------------------
*/
export const getStaffList = (employeeId, page, pageSize) =>
  axios
    .get(`${HC_360_ENDPOINT}/Employees/Subordinates`, {
      headers: {
        EmployeeId: employeeId,
        page,
        pageSize
      }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Leave Request
| @param {string} employeeId
| @param {number} page
| @param {number} pageSize
|--------------------------------------------------
*/
export const getStaffProfile = employeeId =>
  axios
    .get(`${LEAVE_REQUEST_ENDPOINT}/Employees/${employeeId}`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] caculate day off Leave Request
| @param {string} employeeId
| @param {number} page
| @param {number} pageSize
|--------------------------------------------------
*/
export const getDayOff = values =>
  axios
    .get(`${HC_360_ENDPOINT}/LeaveRequest/DaysOff`, {
      headers: values
    })
    .then(response => response.data)



// WEBPACK FOOTER //
// ./src/api/leaveRequest.js